$(document).ready(() => {
  $('#id_voucher-form').on('submit', e => {
    e.preventDefault()
    $('#id_voucher-form')
      .find('.invalid-feedback')
      .first()
      .remove()
    $('#id_discount-voucher').removeClass('is-invalid')
    let csrf = $('#id_voucher-form')
      .find('input')
      .first()
      .val()
    let form = new FormData()
    form.append('voucher', $('#id_discount-voucher').val())
    const opts = {
      method: 'POST',
      credentials: 'include',
      headers: {
        'X-CSRFToken': csrf,
      },
      body: form,
    }
    fetch('/checkout/add-voucher/', opts)
      .then(r => {
        if (r.status === 200) {
          return r.json()
        } else {
          r.json().then(r => {
            $('#id_discount-voucher').addClass('is-invalid')
            if (r.detail && r.detail.voucher && r.detail.voucher.length) {
              $('#id_discount-voucher').after(
                `<div class="invalid-feedback">${r.detail.voucher[0]}</div>`
              )
            } else {
              $('#id_discount-voucher').after(
                '<div class="invalid-feedback">This discount code is unavailable.</div>'
              )
            }
          })
          return false
        }
      })
      .then(r => {
        if (r) {
          let discount = r.discount_value
          let new_tax = r.new_tax
          let oldTotal = Number($('#id_cart-total').contents()[1].data)
          $('#id_cart-total')
            .contents()[1]
            .replaceWith(Number(oldTotal - discount).toFixed(2))
          $('#id_voucher-form').addClass('d-none')
          $('#id_discount-voucher').val('')
          $('#id_remove-voucher').removeClass('d-none')
          $('#id_discount-value').removeClass('d-none')
          $('#id_discount-value')
            .contents()[0]
            .replaceWith(`-$${Number(discount).toFixed(2)}`)
          $('#id_tax-amount')
            .contents()[1]
            .replaceWith(Number(new_tax).toFixed(2))
          $('#id_discount-name')
            .contents()[0]
            .replaceWith(r.discount_name)
          $('#id_cart-total')
            .contents()[1]
            .replaceWith(Number(r.new_total).toFixed(2))
          $('#id_cart-subtotal')
            .contents()[2]
            .replaceWith(Number(r.new_subtotal).toFixed(2))
        }
      })
  })
  $('#id_remove-voucher').on('submit', e => {
    e.preventDefault()
    let csrf = $('#id_voucher-form')
      .find('input')
      .first()
      .val()
    const opts = {
      method: 'POST',
      credentials: 'include',
      headers: {
        'X-CSRFToken': csrf,
        HTTP_X_REQUESTED_WITH: 'XMLHttpRequest',
      },
    }
    $.post('/checkout/remove_voucher/', opts).then(r => {
      $('#id_cart-total')
        .contents()[1]
        .replaceWith(Number(r.new_total).toFixed(2))
      $('#id_tax-amount')
        .contents()[1]
        .replaceWith(Number(r.new_tax).toFixed(2))
      $('#id_cart-subtotal')
        .contents()[2]
        .replaceWith(Number(r.new_subtotal).toFixed(2))
      $('#id_voucher-form').removeClass('d-none')
      $('#id_remove-voucher').addClass('d-none')
      $('#id_discount-value').addClass('d-none')
    })
  })
})
